import type { IconSvgObject } from './types';

const Refresh03Icon: IconSvgObject = [
  ["path", { d: "M19.4845 17C17.8699 19.412 15.1204 21 12 21C7.02944 21 3 16.9706 3 12C3 11.662 3.01863 11.3283 3.05493 11M20.9451 13C20.9814 12.6717 21 12.338 21 12C21 7.02944 16.9706 3 12 3C8.87958 3 6.13007 4.58803 4.51555 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 7H4V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 17L20 17L20 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Refresh03Icon;
